import Dispatcher from 'common/Dispatcher';
import { ActionTypes } from 'search/constants';

export default {
  fetchResultsStart(params, timestamp) {
    Dispatcher.handleServerAction({
      type: ActionTypes.FETCH_RESULTS_START,
      params: params,
      timestamp: timestamp
    });
  },

  fetchResultsSuccess(rawResults, timestamp) {
    Dispatcher.handleServerAction({
      type: ActionTypes.FETCH_RESULTS_SUCCESS,
      rawResults: rawResults,
      timestamp: timestamp
    });
  },

  fetchResultsFailure(failureMessage, timestamp) {
    Dispatcher.handleServerAction({
      type: ActionTypes.FETCH_RESULTS_FAILURE,
      failureMessage: failureMessage,
      timestamp: timestamp
    });
  },

  setInitialResults(initialResults) {
    Dispatcher.handleServerAction({
      type: ActionTypes.SET_INITIAL_RESULTS,
      initialResults: initialResults
    });
  },

  setInitialParams(initialParams) {
    Dispatcher.handleServerAction({
      type: ActionTypes.SET_INITIAL_PARAMS,
      initialParams: initialParams
    });
  }
};
